import React, { useEffect } from 'react'
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { useForm } from "react-hook-form";
import { CustomFileUpload } from "../../../components/CustomFileUpload.jsx"
import * as actions from '../actions/micustomeractions.js'
import quotationService from '../services/micustomerservice.js'

export default function Documents() {

    const { register, handleSubmit, reset, setValue: setDocumentValues, watch, formState: { errors }, clearErrors } = useForm();
    const state = useSelector(state => state.miCustomerSharedReducer);
    const dispatch = useDispatch();
    // let navigate = useNavigate();
    // let quoteInformation = state.quoteInformation;
    // let isMember = state.memberDocuments.isMemberDocument;
    let distinctId = state.quoteDocuments;
    let name = state.memberBasicInfo.enquiryNo;
    let documents = state.quoteDocuments;
    let docList = documents.documentList;
    let currentDocQuoteMembers = state.currentDocQuoteMembers;
    let basicInfoNewEnq = state?.basicInfoNewEnq;
    const location = useLocation();

    const queryParams = new URLSearchParams(location.search);
    const enquiryId = queryParams.get("enquiryId");

    let isCustomerConfirmed = basicInfoNewEnq?.isCustomerConfirmed == true

    useEffect(() => {
        console.log("documents component");
        onResetDocuments();
    }, [name]);

    const onFileChange = (e) => {
        const docIdEncrypted = e.docIdEncrypted;
        const type = e.fileType;
        const field = "fileInput";
        const name = e.fileName;
        const date = new Date();
        let id = e.id.match(/\d+/g);
        id = id[0] - 1;
        dispatch(actions.updateFileChange({ id, field, name, docIdEncrypted, type, date }));
    };

    const handleDocumentChange = (e) => {
        let id = e.target.id.match(/\d+/g)
        id = id[0] - 1;
        var { name, value } = e.target;
        var inputName = name.match(/[a-zA-Z]+/g);
        name = inputName[0];
        dispatch(actions.updateDocumentParams({ id, name, value }));
    }
    // const handleDocumentCheckboxChange = (e) => {
    //     let { id, checked } = e.target;
    //     id = id.match(/\d+/g)
    //     id = id[0]/* == '' ? null : id[0]*/;
    //     dispatch(actions.updateDocumentCheckboxParams({ checked, id }));
    // }
    const onSubmitDocuments = async (e) => {
        // console.log(e);
        await dispatch(actions.saveDocuments(enquiryId));
    }

    const onSaveDocuments = async () => {
        await dispatch(actions.saveDocuments());
    }

    const onErrorDocuments = (errors) => {
        console.log('wewewew', errors);
        let dialogeData = {
            message: 'Please ensure that all documents have been uploaded'/* 'Please make sure all document has been uploaded' */,
            showConfirmPopup: true,
            isConfirm: false,
            isInfo: true,


        }
        dispatch(actions.toggleConfirmPopup(dialogeData));

    }

    const onResetDocuments = (e) => {
        reset();
        clearErrors();
    }
    const onAddNewDocument = async () => {
        await dispatch(actions.addNewDocument());
        reset();
    }
    const onDeleteDocument = async () => {
        await dispatch(actions.deleteDocument());
        await dispatch(actions.updateDocumentTableId());
        /*if (await dispatch(actions.deleteDocument())){
            reset();
        };*/
        reset();
    }
    function renderDocumentComponents() {
        let filterDocList = docList;
        // debugger;
        if (currentDocQuoteMembers) {
            const today = new Date();
            const monthDifference = (today.getFullYear() - new Date(currentDocQuoteMembers?.age).getFullYear()) * 12 + (today.getMonth() - new Date(currentDocQuoteMembers?.age).getMonth());
            const yearDifference = today.getFullYear() - new Date(currentDocQuoteMembers?.age).getFullYear();

            var isNewBorn = monthDifference <= 6;
            var isAbove65 = yearDifference >= 65;
            if (!isNewBorn) {
                filterDocList = filterDocList?.filter(w => w.docTypeId != 27 && w.docTypeId != 28)
            }
            if (!isAbove65) {
                filterDocList = filterDocList?.filter(w => w.docTypeId != 6)
            }

        }
        return (
            <>
                <form onSubmit={handleSubmit(onSubmitDocuments, onErrorDocuments)}>
                    <div className="table-responsive">
                        <table className="table table-hover table-custom ">
                            <thead className="table-header">
                                <tr>
                                    <th className="text-center">Document Type</th>
                                    <th className="text-center">Ref. No</th>
                                    <th className="text-center">Description</th>
                                    <th className="text-center">File Type</th>
                                    <th className="text-center">Uploaded Date</th>
                                    <th className="text-center">Upload</th>
                                    <th className="text-center">File Name</th>
                                    <th className="text-center">View</th>
                                </tr>
                            </thead>

                            {(filterDocList.length > 0) &&
                                <tbody>
                                    {filterDocList.map((doc, index) => (
                                        <tr key={doc.srlNo - 1}>
                                            <td className="text-center">
                                                <select className={errors.hasOwnProperty(`docType${doc.srlNo}${distinctId}`) ? 'form-control is-invalid' : 'form-control'}
                                                    data-toggle="select2" id={"docType " + doc.srlNo + " " + distinctId}
                                                    disabled={doc.isMandatory || isCustomerConfirmed}
                                                    {...register(`docType${doc.srlNo}${distinctId}`, {
                                                        required: !doc.isMandatory, // Ensuring required for mandatory documents
                                                        onChange: (e) => handleDocumentChange(e)
                                                    })}
                                                    value={doc.docType}>
                                                    <option value={doc.docTypeId}>{doc.docType}</option>
                                                </select>
                                            </td>
                                            <td className="text-center">
                                                <input className={errors.hasOwnProperty(`refNo${doc.srlNo} ${distinctId}`) ? 'form-control is-invalid' : 'form-control'}
                                                    type="text" id={"refNo " + doc.srlNo + " " + distinctId}
                                                    disabled={isCustomerConfirmed}
                                                    {...register(`refNo${doc.srlNo}${distinctId}`, {
                                                        required: false,  // Required validation
                                                        onChange: (e) => handleDocumentChange(e)
                                                    })}
                                                    value={doc.refNo}
                                                />
                                            </td>
                                            <td className="text-center">
                                                <input className='form-control'
                                                    type="text" id={"description " + doc.srlNo + " " + distinctId} name='description'
                                                    disabled={isCustomerConfirmed}
                                                    {...register(`description${doc.srlNo}${distinctId}`, {
                                                        required: false,  // Required validation
                                                        onChange: (e) => handleDocumentChange(e)
                                                    })}
                                                    value={doc.description}
                                                />
                                            </td>
                                            <td className="text-center">
                                                <input className='form-control'
                                                    type="text" id={"fileType " + doc.srlNo + " " + distinctId} name='fileType' readOnly={true}
                                                    {...register(`fileType${doc.srlNo}${distinctId}`, {
                                                        onChange: (e) => handleDocumentChange(e)
                                                    })}
                                                    value={doc.fileType}
                                                />
                                            </td>
                                            <td className="text-center">
                                                <input className='form-control'
                                                    type="text" id={"uploadedDate " + doc.srlNo + " " + distinctId} readOnly={true}
                                                    {...register(`uploadedDate${doc.srlNo}${distinctId}`, {
                                                        onChange: (e) => handleDocumentChange(e)
                                                    })}
                                                    value={doc.uploadedDate == null ? "" : new Date(doc.uploadedDate).toLocaleString('en-GB')}
                                                />
                                            </td>
                                            <td className="text-center">
                                                <CustomFileUpload className={errors.hasOwnProperty(`fileInput${doc.srlNo}`) ? 'form-control is-invalid' : 'form-control'}
                                                    id={"fileInput " + doc.srlNo}
                                                    name={`fileInput${doc.srlNo}`}
                                                    disabled={isCustomerConfirmed}
                                                    {...register(`fileInput${doc.srlNo}`, {
                                                        required: (true && !doc.fileInput),  // Make file upload required
                                                    })}
                                                    onChange={e => onFileChange(e)}
                                                    value={doc.fileInput}
                                                    file={doc.fileName}
                                                    hidden={true}
                                                />
                                                <label className={errors.hasOwnProperty(`fileInput${doc.srlNo}`) ? 'btn btn-light btn-outline-danger' : "btn btn-light btn-outline-secondary"}
                                                    for={"fileInput " + doc.srlNo}>Choose File</label>
                                            </td>
                                            <td className="text-center">
                                                <text>{(doc.fileInput === null || doc.fileInput === "" || doc.fileInput === '') ? "No file chosen" : doc.fileName}</text>
                                            </td>
                                            <td className="text-center">
                                                <button type="button" id={doc.srlNo} className="btn btn-primary"
                                                    data-bs-container="#tooltip-container2"
                                                    data-bs-toggle="tooltip" data-bs-placement="bottom" title="download"
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        quotationService.downloadFile(doc.fileInput);
                                                    }}>
                                                    <i className="dripicons-cloud-download"></i></button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            }
                        </table>
                    </div>
                    <div className="row g-2">
                        <div className="mb-1 col-md-4">
                            {filterDocList.length == 0 && <h5 className="alert alert-danger">No Documents Found...</h5>}
                        </div>
                    </div>
                    <div className="row g-2">
                                
                                        <div className="col-md-11">
                                    <span className="redstar">* </span><b> <a href="https://static1.alsagrins.ae/med/manuals/ASNICDataPrivacyConditions.pdf"  target="_blank" rel="noopener noreferrer">Download Data Privacy and Consent Form</a></b>
                                </div>
                    </div>

                    {!isCustomerConfirmed && <div className="modal-footer">
                        <div className="col-md-12">
                            <div className="row g-2">
                                <div className="col-md-11">
                                    {/* <span className="redstar">* </span> Mandatory Documents */}
                                </div>
                                <div className="col-md-1">
                                    <button type="submit" className="btn btn-success btn-group float-end" disabled={isCustomerConfirmed}>Save</button>
                                </div>
                            </div>
                        </div>
                    </div>}
                </form>
            </>
        )
    }
    return (

        // <div id="documents-modal" class="modal fade" data-bs-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="fullWidthModalLabel" aria-hidden="true">
        //     <div class="modal-dialog modal-full-width">
        //         <div class="modal-content">
        //             <div class="modal-header">
        //                 <div className="ribbon-box">
        //                     <div className="ribbon ribbon-primary float-start"><i className="mdi mdi-account-circle-outline me-1"></i>Documents &nbsp;:&nbsp; {name} </div>
        //                 </div>
        //                 <button type="button" className="btn-close" data-bs-dismiss="modal" aria-hidden="true" onClick={(e) => onResetDocuments(e)}></button>
        //             </div>
        //             <div class="modal-body">
        //                 {renderDocumentComponents()}
        //             </div>
        //         </div>
        //     </div>
        // </div>

        <div >
            <div class="modal-dialog modal-full-width">
                <div class="modal-content">
                    {/* <div class="modal-header">

            <div className="ribbon-box">
                <div className="ribbon ribbon-primary float-start"><i className="mdi mdi-account-circle-outline me-1"></i>Documents &nbsp;:&nbsp; {name} </div>
            </div>
            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-hidden="true" onClick={(e) => onResetDocuments(e)}></button>
        </div> */}
                    {/* <div class="modal-body"> */}
                    {renderDocumentComponents()}
                    {/* </div> */}
                </div>
            </div>
        </div>
    )
}